<template>
  <el-footer class="footer">
    <img src="@/assets/img/footer.jpg" class="footer-logo" />
    <div class="footer-box">
      <div class="footer-list">
        <div class="icons">
          <el-link
            href="https://www.facebook.com/profile.php?id=100063665086168"
            target="_blank"
          >
            <img src="@/assets/img/footer1.svg" />
          </el-link>
          <el-link
            href="https://www.instagram.com/maragonconstruccion/"
            target="_blank"
          >
            <img src="@/assets/img/footer2.svg" />
          </el-link>
          <el-link
            href="https://www.linkedin.com/company/maragon-eficiencia-en-construccion/?originalSubdomain=es"
            target="_blank"
          >
            <img src="@/assets/img/footer3.svg" />
          </el-link>
        </div>

        <h1></h1> <!--@click="$router.push('/contacto')"-->
        <div class="footer-text" id="fuera-link">
          CONTACTA CON NOSOTROS
         </div>
        <div class="icon-text">
          <img src="@/assets/img/footer5.svg" />
          <el-link href="tel:603440332"> 603 440 332</el-link>
        </div>
        <div class="icon-text"> 
          <img src="@/assets/img/footer4.svg" />
          <el-link href="mailto:info@maragonconstruccion.es">
            info@maragonconstruccion.es
          </el-link>
        </div>
      </div>
      <div class="footer-list">
        <div class="footer-text" id="fuera-link">PÁGINAS LEGALES</div>
        <div class="links">
          <el-link @click="$router.push('/aviso')">Aviso legal</el-link>
          <el-link @click="$router.push('/cookies')">Política de cookies</el-link>
          <el-link @click="$router.push('/privacidad')">Política de privacidad</el-link>
          <el-link @click="openPdf('5.4PolítiCadeCalidadYmedioAmbiente.pdf')">Política de calidad y medio ambiente</el-link>
        </div>
        <div class="footer-text" id="fuera-link">CERTIFICADOS</div>
        <el-link class="link-img" @click="openPdf('5.5CertificadoDOKCailidad.pdf')">
          <img src="@/assets/img/footer4.png" />
        </el-link>
        <el-link class="link-img" @click="openPdf('5.6CertificadoDOKMedioAmbiente.pdf')">
          <img src="@/assets/img/footer5.png" />
        </el-link>
        <el-link class="link-img" id="fuera-link">
          <img src="@/assets/img/footer6.jpg" />
        </el-link>
      </div>
    </div>
  </el-footer>
</template>

<script>
export default {
  methods: {
    openPdf(name) {
      window.open(`/${name}`);
    },
  },
}
</script>
<style lang="scss" scoped>
.el-footer.footer {
  position: relative;
  padding-left: 40px;
  padding-right: 130px;
  padding-top: 24px;
  padding-bottom: 36px;
  height: auto !important;
  background: $--color-primary;
  $imgW: 690px;

  .el-link {
    font-size:calc( var(--font-size) - 4px);
    color: #fff;
  }
  .footer-logo {
    position: absolute;
    width: $imgW;
    height: 790px;
    bottom: 44px;
    left: 40px;
  }
  .footer-box {
    padding-left: $imgW + 150px;
    display: flex;
    justify-content: space-between;
  }
  .footer-list {
    .icons {
      display: flex;
      margin-bottom: 50px;
      .el-link + .el-link {
        margin-left: 50px;
      }
      img {
        width: 50px;
        height: 50px;
        object-fit: contain;
        cursor: pointer;
      }
    }
    h1 {
      font-size: var(--font-size);
      margin-bottom: 70px;
    }
    .footer-text {
      font-size:calc( var(--font-size) - 2px);
      margin-bottom: 14px;
      font-weight: 600;
      cursor: pointer;
    }
    .icon-text {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 35px;
      }
      .el-link ::v-deep .el-link--inner {
        font-size:calc( var(--font-size) - 4px);
        // letter-spacing: 14px;
      }
    }
    .links {
      margin-bottom: 40px;
      .el-link {
        display: block;
        line-height:calc( var(--font-size) + 6px);
        ::v-deep .el-link--inner {
          font-size:calc( var(--font-size) - 4px);
        }
      }
    }
    .link-img {
      margin-right: 20px;
      img {
        width: 120px;
        height: 120px;
      }
    }
  }
}
</style>
